export default function (state = {}, action) {
   switch (action.type) {

      case 'GET_DEPARTMENT':
         {
            return {
               ...state,
               departmentPayload: action.payload
            };
         }
      default:
         return state;
   }
}
